<template>
  <div class="statistics-table__row" :class="{ _gray: isAgent }">
    <div @click="onOpen"
         class="statistics-table__cell  _partner">
      <StatisticsPageTablePartner v-once
                                  :resume="row.partner"/>

      <transition name="dropdown">
        <StatisticsPageTablePartnerDropWindow v-if="isOpen"
                                              v-once
                                              :resume="row.partner"
                                              :style="dropWindowStyle"
                                              @close="onClose"
                                              class="statistics-table__partner-drop-window"/>
      </transition>
    </div>
    <div v-for="(value, key, index) in mainCells"
         :key="key"
         @mouseenter="$emit('enter-cell', index)"
         @mouseleave="$emit('leave-cell', index)"
         :class="{_hover: hoverCell === index}"
         class="statistics-table__cell">
      {{ row[key] }}
    </div>
  </div>
</template>

<script>
  import {uniqueId} from 'lodash'
  import StatisticsPageTablePartner from "./StatisticsPageTablePartner"
  import StatisticsPageTablePartnerDropWindow from "./StatisticsPageTablePartnerDropWindow"
  import { AGENT } from '../../constants/usersTypes';

  export default {
    name: 'StatisticsPageTableBodyRow',
    components: {
      StatisticsPageTablePartner,
      StatisticsPageTablePartnerDropWindow,
    },
    props: {
      row: Object,
      cells: Object,
      mainCells: Object,
      hoverCell: Number,
      toLastRow: Number,
      isOpen: Boolean
    },
    computed: {
      isAgent() {
        return this.row.partner.user_type === AGENT;
      },
      dropWindowStyle() {
        if (this.toLastRow > 2) return

        return {
          top: `${-0.5 - ((2 - this.toLastRow) * 5.3)}rem`
        }
      }
    },
    methods: {
      onOpen() {
        this.$emit('open')
      },
      onClose() {
        this.$emit('close')
      },
      uniqueId,
    }
  }
</script>

<style lang="less">

</style>
